import React, { useContext } from "react";
import { ThemeContext } from "../../../context/ThemeContext";
import "../../../pages/Landing/LandingPage.css";

const Process = () => {
  const { darkMode } = useContext(ThemeContext);

  return (
    <section className={`process-section py-5 ${darkMode ? "dark-mode" : ""}`}>
      <div className="container">
        <div className="row text-center mb-5">
          <div className="col-12">
            <h2 className="process-main-title">Our Working Procedure</h2>
            <p className="process-subtitle">
              We follow a proven methodology to implement our accounting system
              for your business
            </p>
          </div>
        </div>
        <div className="process-row">
          <div className="process-col col-12 col-lg-4">
            <div className="process-step">
              <div className="step-number">01</div>
              <h3 className="step-title">Needs Assessment</h3>
              <p className="step-text">
                We start with a comprehensive analysis of your business
                requirements, understanding your workflows, volume, and
                reporting needs.
              </p>
            </div>
          </div>
          <div className="process-col col-12 col-lg-4">
            <div className="process-step">
              <div className="step-number">02</div>
              <h3 className="step-title">System Configuration</h3>
              <p className="step-text">
                We set up your system with proper categorization, user roles,
                permissions, and tailor the platform to your specific business
                model.
              </p>
            </div>
          </div>
          <div className="process-col col-12 col-lg-4">
            <div className="process-step">
              <div className="step-number">03</div>
              <h3 className="step-title">Data Migration & Training</h3>
              <p className="step-text">
                We help migrate your existing data and provide comprehensive
                training to ensure your team can maximize the system's
                potential.
              </p>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .process-section {
          padding: 80px 0;
          background-color: ${darkMode ? "#1e1e1e" : "#fff"};
          position: relative;
        }

        .process-main-title {
          font-size: 36px;
          font-weight: 700;
          color: ${darkMode ? "#f5f5f5" : "#333"};
          margin-bottom: 15px;
        }

        .process-subtitle {
          color: ${darkMode ? "#cccccc" : "#666"};
          max-width: 700px;
          margin: 0 auto;
          font-size: 18px;
        }

        .process-row {
          display: flex;
          flex-wrap: wrap;
          gap: 30px;
          justify-content: center;
          align-items: stretch;
        }

        .process-col {
          flex: 1;
          min-width: 300px;
          max-width: 400px;
        }

        .process-step {
          background: ${darkMode ? "#2d2d2d" : "#fff"};
          border-radius: 15px;
          padding: 40px 30px;
          text-align: center;
          box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
          transition: all 0.3s ease;
          height: 100%;
          border: 1px solid ${darkMode ? "rgba(0, 211, 137, 0.2)" : "rgba(0, 0, 0, 0.1)"};
          position: relative;
          overflow: hidden;
        }

        .process-step:hover {
          transform: translateY(-8px);
          box-shadow: 0 15px 35px rgba(0, 0, 0, 0.15);
        }

        .process-step::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 4px;
          background: linear-gradient(90deg, #00d389, #4ade80);
          opacity: 0;
          transition: opacity 0.3s ease;
        }

        .process-step:hover::before {
          opacity: 1;
        }

        .step-number {
          width: 60px;
          height: 60px;
          background: linear-gradient(135deg, #00d389, #4ade80);
          color: white;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 20px;
          font-weight: 700;
          margin: 0 auto 25px;
          transition: all 0.3s ease;
        }

        .process-step:hover .step-number {
          transform: scale(1.1);
          box-shadow: 0 5px 15px rgba(0, 211, 137, 0.4);
        }

        .step-title {
          font-size: 22px;
          font-weight: 600;
          color: ${darkMode ? "#f5f5f5" : "#333"};
          margin-bottom: 20px;
          transition: all 0.3s ease;
        }

        .step-text {
          font-size: 16px;
          color: ${darkMode ? "#cccccc" : "#666"};
          line-height: 1.6;
          transition: all 0.3s ease;
        }

        /* Mobile-specific optimizations */
        @media (max-width: 767.98px) {
          .process-section {
            padding: 40px 0;
          }

          .process-main-title {
            font-size: 28px;
            margin-bottom: 12px;
          }

          .process-subtitle {
            font-size: 16px;
          }

          .process-row {
            gap: 20px;
          }

          .process-col {
            min-width: 100%;
            max-width: 100%;
            flex: 0 0 100%;
          }

          .process-step {
            padding: 30px 25px;
            max-width: 100%;
          }

          .step-number {
            width: 55px;
            height: 55px;
            font-size: 18px;
            margin-bottom: 20px;
          }

          .step-title {
            font-size: 20px;
            margin-bottom: 15px;
          }

          .step-text {
            font-size: 15px;
            line-height: 1.6;
          }
        }

        /* Small mobile devices */
        @media (max-width: 575.98px) {
          .process-main-title {
            font-size: 24px;
          }

          .process-subtitle {
            font-size: 14px;
          }

          .process-row {
            gap: 18px;
          }

          .process-col {
            min-width: 100%;
            max-width: 100%;
            flex: 0 0 100%;
          }

          .process-step {
            padding: 25px 20px;
            max-width: 100%;
          }

          .step-number {
            width: 50px;
            height: 50px;
            font-size: 16px;
            margin-bottom: 18px;
          }

          .step-title {
            font-size: 18px;
            margin-bottom: 12px;
          }

          .step-text {
            font-size: 14px;
            line-height: 1.5;
          }
        }

        /* Extra small devices */
        @media (max-width: 375px) {
          .process-main-title {
            font-size: 22px;
          }

          .process-subtitle {
            font-size: 13px;
          }

          .process-col {
            min-width: 100%;
            max-width: 100%;
            flex: 0 0 100%;
          }

          .process-step {
            padding: 20px 18px;
            max-width: 100%;
          }

          .step-number {
            width: 45px;
            height: 45px;
            font-size: 15px;
            margin-bottom: 15px;
          }

          .step-title {
            font-size: 16px;
            margin-bottom: 10px;
          }

          .step-text {
            font-size: 13px;
            line-height: 1.4;
          }
        }
      `}</style>
    </section>
  );
};

export default Process;
